/* eslint-disable jsx-a11y/no-autofocus */
import { forwardRef } from 'react';
import { IOtpInput } from './otpInput.models';
import { useOtpInput } from './otpInput.hook';
import * as S from './otpInput.style';
import { OneNumberInput } from './components';

export const OtpInput = forwardRef<HTMLInputElement, IOtpInput>(
  (
    {
      autoFocus,
      disabled,
      error: _error,
      errorLines = 1,
      numbers,
      onBlur,
      onChange,
      style,
      styled,
      variant = 'sunrise',
      withAutoFocus = false,
      ...rest
    },
    ref
  ) => {
    const {
      cells,
      errorA,
      errorADelayedThings,
      error,
      focusedRef,
      id,
      innerRef,
      refCallback,
      focusFirstCell,
    } = useOtpInput({
      _error,
      disabled,
      numbers,
      ref,
    });

    return (
      <S.Container
        error={error}
        errorLines={errorLines}
        style={style}
        styled={styled}
        variant={variant}
        onClick={(e) => {
          if (withAutoFocus) {
            e.stopPropagation();
            focusFirstCell(rest.value?.toString());
          }
        }}
      >
        <input
          {...rest}
          aria-errormessage={id}
          aria-invalid={!!error}
          disabled={disabled}
          hidden
          onBlur={onBlur}
          onChange={onChange}
          tabIndex={-1}
          type="number"
          autoComplete="one-time-code"
          ref={refCallback}
          maxLength={6}
        />
        <S.Wrapper>
          <S.Cells variant={variant}>
            {cells.map((item, index) => (
              <OneNumberInput
                aria-invalid={!!error}
                autoFocus={autoFocus && index === 0}
                disabled={disabled}
                focusedRef={focusedRef}
                id={`otp-${item}`}
                inputMode={rest.inputMode}
                error={error}
                key={item}
                onOtpBlur={onBlur}
                onOtpChange={onChange}
                otpRef={innerRef}
                readOnly={
                  innerRef?.current?.value !== undefined && innerRef?.current?.value?.length < index
                }
                cursor={
                  innerRef?.current?.value !== undefined && innerRef?.current?.value?.length < index
                    ? 'not-allowed'
                    : 'pointer'
                }
                variant={variant}
              />
            ))}
          </S.Cells>
        </S.Wrapper>
        {errorA.shouldRender && (
          <S.ErrorMessage
            className={errorA.animationClass}
            errorLines={errorLines}
            id={id}
            onAnimationEnd={errorA.onAnimationEnd}
            role="alert"
            dangerouslySetInnerHTML={{
              __html: errorADelayedThings,
            }}
          />
        )}
      </S.Container>
    );
  }
);

